const endpoint = (append = '') => `${process.env.VUE_APP_PROVIDER}${append}`

export const getBanks = async () => {
  const { data } = await window.axios.get(endpoint('/banks/getbanks'))

  return data
}

export default {
  getBanks
}
